import { HEATMAP_DEVICE_TYPES } from './HeatmapDeviceTypes';

export const HEATMAP_WIDTH_PER_DEVICE = {
  [HEATMAP_DEVICE_TYPES.PHONE]: 380,
  [HEATMAP_DEVICE_TYPES.TABLET]: 800,
  [HEATMAP_DEVICE_TYPES.DESKTOP]: 1280,
};
